import { Component, inject, Input, OnInit } from '@angular/core';
import { AttachmentModel } from 'src/app/core/models/QueryAttachmentModel';
import { ClarificationQueryListService } from '../clarification-query-list.service';
import { NZ_MODAL_DATA, NzModalService } from 'ng-zorro-antd/modal';
import * as fs from 'file-saver';

@Component({
  selector: 'app-view-attachments',
  standalone: false,
  templateUrl: './view-attachments.component.html',
  styleUrl: './view-attachments.component.less'
})
export class ViewAttachmentsComponent implements OnInit  {
  //@Input() queryCode!: number;
  //@Input() queryDetailCode!: number;
  //@Input() queryReferenceNumber!: string;
  //@Input() fileAttachments!: AttachmentModel[];

  readonly nzModalData = inject(NZ_MODAL_DATA);  
  queryReferenceNumber : string = '';
  fileAttachments: AttachmentModel[] = [];
  queryCode : number = 0;
  queryDetailCode : number = 0;

  openQueries : any[] = [];
  SelectAll!: boolean;
  selectedFilesForDownload: AttachmentModel[] = [];
  errorMsg = "Please select files to download";
  displayErrMsg = false;

  constructor(
    private queryService: ClarificationQueryListService, private modalService: NzModalService) { }
    ngOnInit() {
      this.queryReferenceNumber = this.nzModalData.queryReferenceNumber;    
      this.fileAttachments   = this.nzModalData.fileAttachments;   
      this.queryCode = this.nzModalData.queryCode;
      this.queryDetailCode = this.nzModalData.queryDetailCode; 
      this.clearSelection();
    }

    downloadFiles() {
      this.selectedFilesForDownload = this.fileAttachments.filter(s => s.Select);
      if (this.selectedFilesForDownload.length > 0) {
        for (var i = 0; i < this.selectedFilesForDownload.length; i++) {
          let fileName = this.selectedFilesForDownload[i].File_Name;
          
          this.queryService.downloadFile(this.queryCode, this.queryDetailCode, this.queryReferenceNumber + '/' + fileName).subscribe((data: any) => {
            const blob = this.b64toBlob(data.output, 'application/octet-stream', 512);
            fs.saveAs(blob, fileName);
          });
        }        
        this.modalService.closeAll();
        this.clearSelection();
      }
      else {
        this.displayErrMsg = true;
      }
    }
    clearSelection() {
      this.SelectAll = false;
      this.displayErrMsg = false;
      this.selectedFilesForDownload = [];
      this.fileAttachments.forEach(element => { element['Select'] = false; });
    }

    selectAllFiles() {
      this.fileAttachments.forEach(element => { element['Select'] = this.SelectAll; });
      this.displayErrMsg = !(this.SelectAll);
    }
    resetSelectAll() {
      var selectFiles = [];
      selectFiles = this.fileAttachments.filter(element => element.Select == true);
      this.SelectAll = (selectFiles.length == this.fileAttachments.length)
      this.displayErrMsg = (selectFiles.length == 0);
    }
    b64toBlob(b64Data: string, contentType: string, sliceSize: number): Blob {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;
      const byteCharacters: string = atob(b64Data);
      const byteArrays: Uint8Array[] = [];
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice: string = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers: number[] = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray: Uint8Array = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
      }
      const blob: Blob = new Blob(byteArrays, { type: contentType });
      return blob;
    }
}
